module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "pd-25 fs-28"
  }, [_c('div', [_vm._v("抱歉~，扫描结果不匹配，请核对二维码")]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_vm._v(_vm._s(_vm.content))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21ef5fce","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/scanBlank.vue
// module id = 8UZh
// module chunks = 51